module.exports = __webpack_public_path__ + "static/img/bz.87b94d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bz.png
// module id = G82g
// module chunks = 26